export const WEEKS_TO_RENDER = 6;
export const DAYS_PER_WEEK = 7;
export const MONTHS_PER_YEAR = 12;
export const DATEPICKER_MAIN_AXIS_OFFSET = 10;
export const DATEPICKER_CROSS_AXIS_OFFSET = 24;
